import { sendPost } from '../http.js'
const api = {
	'singleUpdate': {
        url: '/user/user/single_update'
    },
	'productUpdate': {
        url: '/user/user/product_update/v2'
    },
	'showUpdate': {
        url: '/user/user/show_update'
    },
    'videoTranscode': {
        url: '/course/video/transcode'
    },
    'createdallshow': {
        url: '/user/user/createdallshow'
    },
    'getSensitive': {
        url: '/user/user/get_sensitive'
    },
    'renewStatus': {
        url: '/user/user/renew_status'
    },
    'userComment': {
        url: '/user/user/comment'
    },
    'courseGetcourse': {
        url: '/author/course/getcourse'
    },
    'addComment': {
        url: '/user/user/add/comment'
    },
    'auditComment': {
        url: '/user/user/audit/comment'
    },
    'delComment': {
        url: '/user/user/del/comment'
    },
    'recallAudit': {
        url: '/user/user/recall/audit'
    },
    'courseLib': {
        url: '/product/dy/course/lib'
    },
    'productsynwx': {
        url: '/user/user/productsynwx'
    },
    'productSetting': {
        url: '/user/user/product/setting'
    },
    'productSettingDetail': {
        url: '/user/user/product/setting/detail'
    },
    'getWxDbzxLinkAPI': { // 获取微信豆包知道、豆包甄选课程链接
        url: '/user/user/setProductWxLink'
    },
    'addMaterialFun': {
        url: '/user/user/product/material/add'
    },
    'materialList': {
        url: '/user/user/product/material_list'
    },
    'materialDetail': {
        url: '/user/user/product/material/detail'
    },
    'materialEdit': {
        url: '/user/user/product/material/edit'
    },
    'materialDel': {
        url: '/user/user/product/material/del'
    },
    'materialProduct': {
        url: '/user/user/material/product'
    }
}
const requestFunObj = {}
for (const key in api) {
    requestFunObj[key]  = {
        mutationsName: api[key].mutationsName,
        requestFun:(params) => {
            return sendPost(api[key].url, params)
        }
    } 
}
export default requestFunObj
